import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

// PropTypes
import { jobPropTypes } from '../../../../../proptypes/jobProptypes';

// Icons
import { Pin } from '../../../../icons';

// Styles
import styles from '../jobBulletpoints.module.scss';

const JobLocations = ({ job, textColor }) => {
  const router = useRouter();
  const { location: queryParamJobLocation } = router.query;

  const calculateLocations = () => {
    const locationsMap = {};

    if (job.location_country) {
      locationsMap[job.location_country] = [
        {
          city: job.location_city || '',
          lat: job.location_lat,
          lng: job.location_lng,
        },
      ];
    }
    job.additional_locations_details?.forEach((loc) => {
      if (!locationsMap[loc.country]) {
        locationsMap[loc.country] = [
          {
            city: loc.city || '',
            lat: loc.lat,
            lng: loc.lng,
          },
        ];
      } else if (
        loc.city &&
        !locationsMap[loc.country]?.some((item) => item.city === loc.city)
      ) {
        locationsMap[loc.country].push({
          city: loc.city || '',
          lat: loc.lat,
          lng: loc.lng,
        });
      }
    });

    return locationsMap;
  };

  const formatQueryParamLocation = () => {
    const cleanLocationString = queryParamJobLocation
      ? decodeURIComponent(queryParamJobLocation.replaceAll('_', ' '))
      : '';
    const locationArray = cleanLocationString.split(',');
    const country = locationArray.pop();
    const city = locationArray.join(', ');
    const locationMap = {
      [country]: [
        {
          city,
          lat: '',
          lng: '',
        },
      ],
    };

    return locationMap;
  };

  const locations = queryParamJobLocation
    ? formatQueryParamLocation()
    : calculateLocations();

  const LocationMapLink = ({ cityDetails }) => {
    const { city, lat, lng } = cityDetails;

    return lat && lng ? (
      <a
        href={`http://www.google.com/maps/place/${lat},${lng}`}
        target="_blank"
        rel="noreferrer"
      >
        {city}
      </a>
    ) : (
      city
    );
  };
  return (
    <>
      {Object.keys(locations).map((location, index) => (
        <div key={location} className={styles.container}>
          <span className={styles.content}>
            <span className={styles.iconWrapper}>
              <Pin fill={textColor} className={styles.icon} />
            </span>
            <span className={styles.text} data-testid={`location-${index}`}>
              {locations[location]?.map((city) => {
                if (!city.city) return null;

                return (
                  <span key={`location-${index}-${city.city}`}>
                    <LocationMapLink cityDetails={city} />,{' '}
                  </span>
                );
              })}
              {location}
            </span>
          </span>
        </div>
      ))}
    </>
  );
};

JobLocations.propTypes = {
  job: PropTypes.shape(jobPropTypes).isRequired,
  textColor: PropTypes.string.isRequired,
};

export default JobLocations;
